import styled from '@emotion/styled'
import { breakpoints, palette, spacing, Text, typography } from 'main/ui'

export const ContentContainer = styled.div`
  width: 100%;
  margin-bottom: ${spacing.majorScale(3)}px;
`

export const AvailabilityContainer = styled.div`
  width: 100%;
  margin: ${spacing.majorScale(3)}px 0;
`

export const BadgeContainer = styled.div`
  width: 100%;
  height: 64px;
  border-radius: 10px;
  background-color: ${palette.whiteDove};
  margin: ${spacing.minorScale(2)}px 0;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const SubmitContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-evenly;
`

export const Tree = styled.img`
  width: 40px;
  height: 54px;
`

export const BadgeIconContainer = styled.div`
  width: 52px;
  height: 48px;
`

export const BadgeTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  margin-left: ${spacing.majorScale(1)}px;

  @media (min-width: ${breakpoints.sm}px) {
    flex-direction: row;

    > :not(:last-child) {
      margin-right: ${spacing.majorScale(2)}px;
    }
  }
`

export const BadgeText = styled(Text)`
  font-weight: ${typography.fontWeight.bold};
  font-size: 16px;
`

export const BadgePreviewText = styled(Text)<{ bold?: boolean }>`
  color: ${palette.slate};
  font-size: 16px;
`

export const OpenBadgeContainer = styled.div`
  width: 100%;
  height: 90px;
  border-radius: 10px;
  background-color: ${palette.cosmicLatte};
  margin: ${spacing.minorScale(2)}px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`
export const BadgeSubContainer = styled.div`
  width: 100%;
  height: 30px;
  border-radius: 10px;
  background-color: ${palette.cosmicLatte};
  display: flex;
  justify-content: center;
  align-items: center;
`
export const BadgeSubText = styled(Text)`
  font-size: 14px;
`
